import i18next from 'i18next';
import { LOGIN } from '../routes/routes';
import {
  getAccessToken,
  getRefreshToken,
  getUserFromLS,
  removeUserFromLS,
  setNewAccessToken,
  setUserToLS
} from './localstorage-helper';
import { decodeJwt } from './helperFunctions';

window.axios = require('axios');

const API_URL = process.env.REACT_APP_API_URL;

// window.axios.defaults.baseURL = API_URL;

// window.axios.defaults.headers.common['Content-Type'] = 'application / json';

async function refreshToken() {
  const response = await window.axios.put(`/authorization/token/refresh`, {
    refreshToken: getRefreshToken()
  });

  const userInfo = getUserFromLS();

  const user = {
    ...userInfo,
    userType: decodeJwt(response.data.data.accessToken)
  };

  setUserToLS(user);

  let newAccessToken = response.data.data.accessToken;

  setNewAccessToken(newAccessToken);
}

window.axios.interceptors.request.use(
  function (config: any) {
    config.baseURL = config.baseURL || API_URL;
    config.headers.common['Content-Type'] = 'application / json';
    config.headers.Authorization =
      config.headers.Authorization || `Bearer ${getAccessToken()}`;
    config.headers.Language = i18next.language;
    config.headers['Website-Module-Id'] = 3;
    config.headers['Region-Type'] = 1;
    config.headers['User-Origin'] = 2;
    return config;
  },
  function (err: any) {
    // console.log(err);
    return err;
  }
);

window.axios.interceptors.response.use(
  function (response: any) {
    return response;
  },
  async function (error: any) {
    if (error.response) {
      const { status, data } = error.response;
      // console.log('ERROR');

      switch (status) {
        case 401:
          if (data.error === 'Authorization header is not valid!') {
            try {
              await refreshToken();
              const config = error.config;
              return await window.axios({
                method: config.method,
                url: config.url,
                data: config.data,
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            } catch (e) {
              removeUserFromLS();
              return (window.location.href = LOGIN);
              // return alert('ALO BE STRALE BE ERROR BE');
            }
          } else {
            removeUserFromLS();
            return (window.location.href = LOGIN);
            // return alert('ALO BE STRALE BE ERROR BE 2');
          }
        default:
          return Promise.reject(error);
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      return Promise.reject(error);
    } else {
      // Something happened in setting up the request that triggered an Error
      return Promise.reject(error);
    }
  }
);
